// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"268":"Home","443":"RichTextEditor","451":"VideoPreview","793":"WebinarDetail","945":"Video"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".bundle.js";
};